// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__3g6J5","grid_item":"style_grid_item__2xWCj","item__icon":"style_item__icon__TSWYa","item__title":"style_item__title__2HGrF"};